module.exports = __webpack_public_path__ + "img/logo28.0c3a00bf.jpg";